/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyTenge = createReactComponent("outline", "currency-tenge", "IconCurrencyTenge", [["path", { "d": "M6 5h12", "key": "svg-0" }], ["path", { "d": "M6 9h12", "key": "svg-1" }], ["path", { "d": "M12 9v10", "key": "svg-2" }]]);

export { IconCurrencyTenge as default };
//# sourceMappingURL=IconCurrencyTenge.mjs.map
